import React from 'react';
import {changeBraceletLength} from "../lib/actions";
import {connect} from "react-redux";

class LengthSelector extends React.Component {
    render() {
        return (
            <div className='product__options'>
                <div className="product__length-option-name-container">
                    <h4 className="product__option-name">Length</h4>
                    <a href="/pages/necklace-size-guide" target="_blank">Size Guide</a>
                </div>
                <div className="product__swatch-container swatch-bracelet-size-container">
                    <div className="product__range-value">{ this.props.selectedLength }"</div>
                    <input
                        className="product__range range-background"
                        type='range'
                        name='Length'
                        min={5}
                        max={9}
                        step={.25}
                        value={this.props.selectedLength}
                        onChange={(e) => this.props.onChange(e.target.value)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedLength: state.braceletLength,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (braceletLength) => {
            dispatch(changeBraceletLength(braceletLength));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LengthSelector);
